import { createSelector } from 'reselect'
import { getLocaleDateStringFromSeconds } from 'lib/date'
import { getFirstParagraph, getIsDetailPage } from './app'
import { getCollectionOwnerName, getCreatedAt, getCollectionOwnerId } from './collection'
export const getCreatedAtDate = createSelector(
  getCreatedAt,
  (createdAt): string => getLocaleDateStringFromSeconds(createdAt) || ''
)
export const getBreadcrumbSchema = createSelector(
  [getCollectionOwnerName, getCollectionOwnerId],
  (collectionOwnerName, ownerId) => {
    return {
      '@context': 'http://schema.org',
      type: 'BreadcrumbList',
      itemListElement: [
        {
          type: 'ListItem',
          position: 1,
          item: {
            '@id': 'https://www.saatchiart.com/all',
            name: 'All Artworks',
          },
        },
        {
          type: 'ListItem',
          position: 2,
          item: {
            '@id': 'https://www.saatchiart.com/collections',
            name: 'Collections',
          },
        },
        {
          type: 'ListItem',
          position: 3,
          item: {
            '@id': `https://www.saatchiart.com//account/collection/${ownerId}`,
            name: `${collectionOwnerName} Collections`,
          },
        },
      ],
    }
  }
)
export const getMetaData = createSelector(
  [getFirstParagraph, getIsDetailPage],
  (firstParagaph, isDetailPage): Record<string, any> => {
    const title = 'Digital Exhibitions | Saatchi Art'
    const DEFAULT_DESCRIPTION =
      'Enjoy our rich history of Digital Exhibitions where we collaborate with brick-and-mortar galleries and various other organizations to exhibit the work of some of our most promising artists in shows around the globe.'
    const description = isDetailPage ? firstParagaph : DEFAULT_DESCRIPTION
    return {
      description,
      title,
      og: {
        description,
        title,
        ttl: '2419200',
        type: 'article',
      },
      preloadImages: [],
      robots: true,
      schema: {
        webpage: {
          headline: title,
          description,
        },
      },
    }
  }
)
